// MRD:  Note to self.  Do NOT include this module in the app.module as this will 
// incur cyclic dependencies via SharedModule>Services

import { Injector, NgModule } from '@angular/core';
import { MessageService } from './message.service';

@NgModule({
    declarations: [],
    imports     : [],
    exports     : [],
    providers   : [ MessageService ],
})
export class MessageModule
{
    constructor(private injector: Injector){
        messageService = this.injector.get(MessageService);
      }
}

export let messageService: MessageService;
